export const dlCartAddEvent = (newItem, cart) => {
    window.dataLayer.push({
        event: 'Add to cart',
        cart: {
            product: newItem
        }
    });
};
